// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"303":"e74b3c46","522":"16906b13","549":"8d3d349b","897":"bb76593d"}[chunkId] + ".chunk.css";
};